import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { useQuery } from '@tanstack/react-query';
import { getCountry } from '../../../helpers/common';
import user from '../../../helpers/user';
import { IEntitlementService } from '@intigral/domain/lib/application/services/EntitlementService';
import { isGuestUser } from '../../../config/guestMode';

const fetchAllSubscriptionTierFeed = async () => {
    try {
        const { apiKey, productKey, identityToken } = await user.getUserInfo();
        const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
        const data = await entitlementService.getAllSubscriptionTiers(
            apiKey,
            getCountry(),
            'PC',
            productKey,
            identityToken
        );
        if (data) {
            return data;
        }
    } catch (error) {
        throw error.message;
    }
};

export const allTiersSubscriptionsQueryOptions = {
    queryKey: ['all_sub_tier'],
    queryFn: () => fetchAllSubscriptionTierFeed(),
    staleTime: 10 * 60 * 1000, // Consider data stale after 10 minutes
};

export const useAllSubscriptionTier = () => {
    return useQuery({
        ...allTiersSubscriptionsQueryOptions,
        enabled: !isGuestUser(user.getUserInfo()),
    });
};
